import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface OnboardingState {
  welcomeStep: 0 | 1 | 2 | 3;
  childSetupStep: 0 | 1 | 2 | 3;
  childName: string;
  childAge: number | null;
  childInterests: string[];
  createdChildId: string | null;

  setWelcomeStep: (step: 0 | 1 | 2 | 3) => void;
  setChildSetupStep: (step: 0 | 1 | 2 | 3) => void;
  setChildName: (name: string) => void;
  setChildAge: (age: number | null) => void;
  toggleInterest: (interest: string) => void;
  setCreatedChildId: (id: string | null) => void;
  resetOnboarding: () => void;
}

const initialState = {
  welcomeStep: 0 as const,
  childSetupStep: 0 as const,
  childName: '',
  childAge: null as number | null,
  childInterests: [] as string[],
  createdChildId: null as string | null,
};

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set) => ({
      ...initialState,

      setWelcomeStep: (step) => set({ welcomeStep: step }),
      setChildSetupStep: (step) => set({ childSetupStep: step }),
      setChildName: (name) => set({ childName: name }),
      setChildAge: (age) => set({ childAge: age }),
      toggleInterest: (interest) =>
        set((state) => ({
          childInterests: state.childInterests.includes(interest)
            ? state.childInterests.filter((i) => i !== interest)
            : [...state.childInterests, interest],
        })),
      setCreatedChildId: (id) => set({ createdChildId: id }),
      resetOnboarding: () => set(initialState),
    }),
    {
      name: 'mindora-onboarding',
      partialize: (state) => ({ createdChildId: state.createdChildId }),
    },
  ),
);
